import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  toggle() {
    this.element.classList.toggle('scroll-to-top--visible', window.scrollY > 300)
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }
}
